// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pagination_wrapper__9cMMh","label":"pagination_label__RUzBL","progress":"pagination_progress__p0xiE","action":"pagination_action__HXu2u"};